module.exports = __webpack_public_path__ + "img/table2.b58f5195.png";